var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right",
    clipPath: "url(#clip0_3102_39603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Right Line",
    d: "M7.64949e-07 18.75C1.14907 18.75 2.28688 18.5237 3.34848 18.0839C4.41008 17.6442 5.37467 16.9997 6.18719 16.1872C6.9997 15.3747 7.64422 14.4101 8.08395 13.3485C8.52368 12.2869 8.75 11.1491 8.75 9.99999C8.75 8.85093 8.52367 7.71311 8.08394 6.65151C7.64421 5.58991 6.99969 4.62532 6.18718 3.81281C5.37466 3.00029 4.41007 2.35578 3.34847 1.91605C2.28687 1.47632 1.14906 1.25 -1.06395e-05 1.25",
    stroke: "#2E2E38",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3102_39603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.914391eac9944f7c939ef495ab771ded.svg";
export { ForwardRef as ReactComponent };